module.exports = __webpack_public_path__ + "media/assets/images/flags/si-f4ece6b15939a15ec8fc9fe2339f3ebf.svg";